(function () {
    'use strict';

    angular.module("imApp").factory("tailorAccessLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTailorAccessLang: function (parms) {
                return $ihttp.post({
                    method: 2098,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 2099,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
